import { Box, Typography } from '@mui/material';
import React from 'react';
import { SECONDARY_BUTTON_HOVER_SX, StyledButton } from '../../styles/StyledButtons';

interface DeleteConfirmBarProps {
  message: string;
  deleting: boolean;
  error: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Inline confirm-then-delete bar shown under a Media tab video card. */
export default function DeleteConfirmBar({
  message,
  deleting,
  error,
  onCancel,
  onConfirm,
}: DeleteConfirmBarProps) {
  return (
    <Box sx={{ mt: 0.5, p: 1, borderRadius: 1, bgcolor: 'action.hover' }}>
      <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>
        {message}
      </Typography>
      {error && (
        <Typography variant="caption" color="error.main" sx={{ display: 'block', mb: 0.5 }}>
          {error}
        </Typography>
      )}
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
        <StyledButton
          compact
          noTopSpacing
          buttonVariant="inactiveOrCancel"
          sx={SECONDARY_BUTTON_HOVER_SX}
          onClick={onCancel}
          disabled={deleting}
        >
          Cancel
        </StyledButton>
        <StyledButton
          compact
          noTopSpacing
          buttonVariant="warning"
          onClick={onConfirm}
          disabled={deleting}
        >
          Delete
        </StyledButton>
      </Box>
    </Box>
  );
}
